<template>
  <div class="household-shopper">
    <h1>Household Shopper</h1>
    <div v-show="inited">
      <p v-if="householdShopper">
        Your current household shopper is:
        <span class="has-text-weight-bold">
          {{ householdShopper }}
        </span>
      </p>
      <p v-if="!householdShopper">
        You do not currently have a household shopper.
      </p>
    </div>
  </div>
</template>

<script>
export default {
    name: 'HouseholdShopper',
    data() {
        return {
            householdShopper: null,
            inited: false,
        }
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // go ahead and fetch data if someone is logged in
            if (this.$store.state.user.uuid) {
                this.fetchData()
            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // we did it!
            this.inited = true
        },

        fetchData() {
            this.$http.get('/api/my/household-shopper').then(response => {
                if (response.data.error) {
                    // TODO: should be smarter than just knee-jerk redirect?
                    this.$router.push('/')
                } else {
                    this.householdShopper = response.data.household_shopper
                }
            }, response => {
                // TODO: should be smarter than just knee-jerk redirect?
                this.$router.push('/')
            })
        },
    },
}
</script>
